import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class SUPERPOWERG extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">SUPERPOWER G</h1>
        </header>

        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3741 (E) Dated 13-08-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (21) Humic acid 1.2% (Granules)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Humic acid (source: Leonardite) per cent. by weight, minimum: 1.2</li>
                <li>(ii) Bentonite per cent. by weight, maximum: 98.8</li>
                <li>(iii) Total (per cent.): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Soybean, Potato, Chilli and Paddy</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>(i) Soybean: Two soil applications at 10 kg/ha</li>
                <li>(ii) Potato: Two soil applications at 12.5 kg/ha</li>
                <li>(iii) Paddy: Two soil applications at 10 kg/ha</li>
                <li>(iv) Chilli: Two soil applications at 20 kg/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3648 (ई) दिनांक 13-08-2025</li>
            <li><span className="label">2. जैवउत्तेजक का शीर्षक:</span> (21) ह्यूमिक अम्ल 1.2% (कणिकाएँ)</li>
            <li><span className="label">3. संरचना:</span>
              <ul>
                <li>(i) ह्यूमिक अम्ल (स्रोत: लियोनार्डाइट) भार के अनुसार प्रतिशत. न्यूनतम: 1.2</li>
                <li>(ii) बेंटोनाइट भार के अनुसार प्रतिशत. अधिकतम: 98.8</li>
                <li>(iii) कुल (प्रतिशत.): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> सोयाबीन, आलू, मिर्च और धान</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>(i) सोयाबीन: 10 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
                <li>(ii) आलू: 12.5 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
                <li>(iii) धान: 10 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
                <li>(iv) मिर्च: 20 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> एस.ओ.३६४८ (ई) दिनांक १३-०८-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (२१) ह्युमिक आम्ल १.२% (ग्रॅन्युल्स)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(१) ह्युमिक आम्ल (स्रोत: लिओनार्डाइट) टक्के. वजनाने, किमान: १.२</li>
                <li>(२) बेंटोनाइट टक्के. वजनाने, कमाल: ९८.८</li>
                <li>(३) एकूण (टक्के.): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> सोयाबीन, बटाटा, मिरची आणि भात</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>(१) सोयाबीन: १० किलो/हेक्टर दराने मातीचे दोन वापर</li>
                <li>(२) बटाटा: १२.५ किलो/हेक्टर दराने मातीचे दोन वापर</li>
                <li>(३) भात: १० किलो/हेक्टर दराने मातीचे दोन वापर</li>
                <li>(४) मिरची: २० किलो/हेक्टर दराने मातीचे दोन वापर</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    )
  }
}
